/**
 * Правила очереди отправки — чистыми функциями (правило 37).
 *
 * Очередь живёт в IndexedDB, а решения о ней — здесь: чья операция, какая
 * вытеснена новой, что помечается при смене человека на планшете. Так их
 * можно проверить тестом без браузерной базы.
 */

export interface OutboxLike {
  clientMutationId: string;
  entityId: string;
  operation: 'create' | 'update' | 'complete';
  /** Чья операция; пусто — того, кто сейчас вошёл */
  userId?: string | null;
}

/** Операция того, кто вошёл: без метки — его, с меткой — только своя */
export function isOwnOperation(op: Pick<OutboxLike, 'userId'>, userId: string | null | undefined): boolean {
  return !op.userId || op.userId === userId;
}

/**
 * Какие операции вытесняет новое «Завершить»: прежние завершения ТОГО ЖЕ
 * наряда того же человека. Последнее несёт замер целиком (правило 25), а
 * прежнее — отклонённое или ещё не ушедшее — «Повторить» отправило бы
 * поверх новой сметы. Чужие не трогаются: их отправит их хозяин.
 */
export function supersededBy(
  queue: OutboxLike[],
  next: Pick<OutboxLike, 'entityId' | 'operation'>,
  userId?: string | null,
): string[] {
  if (next.operation !== 'complete') return [];
  // Своё — и без метки, и помеченное собой: планшет мог уйти к другому и
  // вернуться, и прежнее «Завершить» хозяина носит его метку
  return queue
    .filter((o) => o.entityId === next.entityId && o.operation === 'complete' && isOwnOperation(o, userId))
    .map((o) => o.clientMutationId);
}

/** Что пометить прошлым человеком при передаче планшета: всё ещё не помеченное */
export function toHandOver<T extends OutboxLike>(queue: T[], previousUserId: string): T[] {
  return queue.filter((o) => !o.userId).map((o) => ({ ...o, userId: previousUserId }));
}
